import { useMemo } from "react";
import { useLang } from "../context/LangContext";
import "../styles/pages/OurMilestones.css";

function MilestoneIcon({ name }) {
  const shared = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  switch (name) {
    case "bulb":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            {...shared}
            d="M9 18h6M10 21h4M8.5 14.5c-1.3-1.1-2.5-2.8-2.5-5a6 6 0 1 1 12 0c0 2.2-1.2 3.9-2.5 5-.7.6-1 1.2-1 2H9.5c0-.8-.3-1.4-1-2Z"
          />
        </svg>
      );

    case "building":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            {...shared}
            d="M3 21h18M6 21V7h5v14M11 21V4h7v17M8 10h1M8 13h1M8 16h1M14 8h1M17 8h1M14 11h1M17 11h1M14 14h1M17 14h1"
          />
        </svg>
      );

    case "globe":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            {...shared}
            d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3 12h18M12 3c2.5 2.4 4 5.6 4 9s-1.5 6.6-4 9c-2.5-2.4-4-5.6-4-9s1.5-6.6 4-9Z"
          />
        </svg>
      );

    case "chat":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            {...shared}
            d="M7 18.5c-2.8-1.3-4.5-3.6-4.5-6.5C2.5 7.6 6.8 4.5 12 4.5s9.5 3.1 9.5 7.5S17.2 19.5 12 19.5c-1.3 0-2.6-.2-3.7-.6L4 20l1.1-3.2"
          />
        </svg>
      );

    case "chart":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path {...shared} d="M4 20h16M7 16V10M12 16V6M17 16v-3" />
          <path
            fill="currentColor"
            d="M7 10a1 1 0 1 0 0 .01M12 6a1 1 0 1 0 0 .01M17 13a1 1 0 1 0 0 .01"
          />
        </svg>
      );

    case "puzzle":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            {...shared}
            d="M10 4c0-1.1.9-2 2-2s2 .9 2 2v1h2.5A1.5 1.5 0 0 1 18 6.5V9h1a2 2 0 1 1 0 4h-1v2.5a1.5 1.5 0 0 1-1.5 1.5H14v1a2 2 0 1 1-4 0v-1H7.5A1.5 1.5 0 0 1 6 15.5V13H5a2 2 0 1 1 0-4h1V6.5A1.5 1.5 0 0 1 7.5 5H10V4Z"
          />
        </svg>
      );

    case "rocket":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            {...shared}
            d="M12 2C12 2 7 7 7 13a5 5 0 0 0 10 0c0-6-5-11-5-11ZM9 14s-2 1-2 3h10c0-2-2-3-2-3M12 8v4"
          />
        </svg>
      );

    case "star":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            {...shared}
            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2Z"
          />
        </svg>
      );

    case "badge":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path {...shared} d="M8 3h8l2 4-6 14L6 7l2-4Z" />
          <path {...shared} d="M8 3l4 18M16 3l-4 18M6 7h12" />
        </svg>
      );

    case "award":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            {...shared}
            d="M12 15.5A6.5 6.5 0 1 0 12 2.5a6.5 6.5 0 0 0 0 13Z"
          />
          <path
            {...shared}
            d="M9.5 8.8 11.3 10.6 14.8 7.1M8.5 14.5 6.8 21l5.2-3 5.2 3-1.7-6.5"
          />
        </svg>
      );

    case "gear":
    default:
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            d="M12 8.5A3.5 3.5 0 1 0 12 15.5A3.5 3.5 0 1 0 12 8.5Z"
          />
          <path
            {...shared}
            d="M19 12a7 7 0 0 0-.1-1l2-1.6-2-3.4-2.4 1a7.3 7.3 0 0 0-1.7-1l-.3-2.6h-4l-.3 2.6a7.3 7.3 0 0 0-1.7 1l-2.4-1-2 3.4 2 1.6a7 7 0 0 0 0 2l-2 1.6 2 3.4 2.4-1a7.3 7.3 0 0 0 1.7 1l.3 2.6h4l.3-2.6a7.3 7.3 0 0 0 1.7-1l2.4 1 2-3.4-2-1.6c.1-.3.1-.7.1-1Z"
          />
        </svg>
      );
  }
}

function MilestoneCard({ item }) {
  return (
    <div className="ourmilestones-card">
      {item.image ? (
        <div className="ourmilestones-card-image-wrap">
          <img
            src={item.image}
            alt={item.imageAlt || item.title}
            className="ourmilestones-card-image"
            loading="lazy"
            decoding="async"
          />
        </div>
      ) : null}

      <div className="ourmilestones-card-body">
        <div className="ourmilestones-item-top">
          <span className="ourmilestones-year">{item.year}</span>
        </div>

        <h3 className="ourmilestones-item-title">{item.title}</h3>

        <p className="ourmilestones-item-text">{item.text}</p>
      </div>
    </div>
  );
}

export default function OurMilestones() {
  const { dict } = useLang();

  const content = useMemo(() => {
    const source = dict?.ourMilestones ?? {};

    return {
      title: source.title ?? "",
      text: source.text ?? "",
      items: Array.isArray(source.items) ? source.items : [],
    };
  }, [dict]);

  if (!content.items.length) return null;

  return (
    <section
      className="ourmilestones-section page-section"
      id="our-milestones"
      aria-label={content.title || "Our milestones"}
    >
      <div className="ourmilestones-shell">
        <header className="ourmilestones-header">
          {content.title ? (
            <h2 className="ourmilestones-title">{content.title}</h2>
          ) : null}

          {content.text ? (
            <p className="ourmilestones-text">{content.text}</p>
          ) : null}
        </header>

        <div
          className="ourmilestones-desktop"
          role="list"
          style={{
            gridTemplateColumns: `repeat(${content.items.length}, minmax(0, 1fr))`,
          }}
        >
          <div className="ourmilestones-desktop-line" aria-hidden="true" />

          {content.items.map((item, index) => (
            <article
              key={`${item.year}-${item.title}-${index}`}
              className={[
                "ourmilestones-item",
                item.image ? "ourmilestones-item--featured" : "",
                `ourmilestones-item--${item.color || "cyan"}`,
              ]
                .filter(Boolean)
                .join(" ")}
              role="listitem"
            >
              <div className="ourmilestones-node" aria-hidden="true">
                <div className="ourmilestones-marker">
                  <div className="ourmilestones-marker-icon">
                    <MilestoneIcon name={item.icon} />
                  </div>
                </div>
              </div>

              <MilestoneCard item={item} />
            </article>
          ))}
        </div>

        <div className="ourmilestones-mobile" role="list">
          {content.items.map((item, index) => (
            <article
              key={`${item.year}-${item.title}-mobile-${index}`}
              className={[
                "ourmilestones-mobile-item",
                item.image ? "ourmilestones-mobile-item--featured" : "",
                `ourmilestones-item--${item.color || "cyan"}`,
              ]
                .filter(Boolean)
                .join(" ")}
              role="listitem"
            >
              <div className="ourmilestones-mobile-rail" aria-hidden="true">
                <span className="ourmilestones-mobile-line" />

                <div className="ourmilestones-mobile-icon-wrap">
                  <div className="ourmilestones-mobile-icon">
                    <MilestoneIcon name={item.icon} />
                  </div>
                </div>
              </div>

              <MilestoneCard item={item} />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}